<template lang="html">
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
    <path d="M9.73201 6.78243C12.8264 6.76156 15.3515 9.25293 15.3726 12.3467C15.3935 15.4404 12.9026 17.966 9.80827 17.9873C6.71378 18.0083 4.18794 15.5168 4.16676 12.423C4.1457 9.32908 6.63743 6.80349 9.73201 6.78243Z" stroke="#1B294A" stroke-width="1.5"/>
    <rect x="0.751363" y="0.748344" width="11.1492" height="11.1529" rx="2.25" transform="matrix(0.999998 -0.00220682 0.00181918 0.999998 -0.00135954 0.0294914)" stroke="#1B294A" stroke-width="1.5"/>
    <path d="M13.6929 2.82821C16.7181 2.80766 19.187 5.24294 19.2076 8.26738C19.2282 11.2918 16.7926 13.7605 13.7675 13.7811C10.7423 13.8017 8.2734 11.3664 8.25281 8.34192C8.23225 5.31746 10.6678 2.8488 13.6929 2.82821Z" stroke="#3CB391" stroke-width="1.5"/>
  </svg>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: 'IconNews'
}
</script>
